/*
  Zenino: "Cumparate frecvent impreuna".
  Blocul vine gata randat de server, deci apare odata cu pagina, fara nicio cerere. Aici doar:
  - bifezi sau debifezi produse si alegi varianta: totalul se schimba pe loc;
  - butonul principal "Adauga in cos" pune produsul paginii, apoi cele bifate (window.znFbt.addPicked);
  - produsul principal urmeaza varianta aleasa sus, in pagina, si stie cand e deja in cos;
    atunci blocul are butonul lui pentru cele bifate;
  - testul cu produsul mai scump (grupa A sau B, tinuta pe telefon) merge pe produse ca proprietate ascunsa _zn_fbt.
*/
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('zn-fbt')) return;

  function formatMoney(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}} lei';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return fmt.replace(re, value);
  }

  /* aceeasi imagine din CDN-ul Shopify, la latimea ceruta */
  function sized(src, width) {
    if (!src) return '';
    var clean = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function cartAddUrl() {
    var routes = window.theme && window.theme.routes;
    var base = routes && routes.cartAdd ? routes.cartAdd : '/cart/add';
    return /\.js$/.test(base) ? base : base + '.js';
  }

  /* o singura cerere pentru toate produsele; intoarce raspunsul Shopify sau arunca mesajul de eroare */
  async function addItems(items) {
    const drawer = document.querySelector('cart-drawer');
    const drawerSection = drawer && drawer.closest('.shopify-section');
    const sections = ['cart-icon-bubble'];
    if (!window.kachingCartApi && drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));
    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      const error = new Error('cart');
      /* mesajul Shopify il aratam doar cand spune ceva despre produs (stoc, cantitate: 422);
         restul (ex. "Please try again in a few minutes" la prea multe cereri) vine in engleza: mesajul nostru */
      error.description = res.status === 422 && typeof data.description === 'string' ? data.description : '';
      throw error;
    }
    return data;
  }

  /* Zenino: cosul instant (zn-cart.js) — doar cand exista sertarul temei; pe pagina de cos ramane calea veche */
  function instant() {
    return window.znCart && !window.kachingCartApi && document.getElementById('cart-drawer') && !document.querySelector('cart-items:not(#cart-drawer cart-items)');
  }

  /* randul provizoriu din cos pentru un produs din bloc: poza, numele, varianta si pretul pe care le vede clientul */
  function lineOf(el, fallbackTitle) {
    const img = el.querySelector('[data-zn-img]') || el.querySelector('img');
    const name = el.querySelector('.zn-fbt__name, .zn-deal__name');
    const select = el.querySelector('select');
    const option = select ? select.options[select.selectedIndex] : null;
    const nowEl = el.querySelector('[data-zn-deal-now]');
    return {
      id: Number(el.dataset.id),
      qty: 1,
      title: name ? name.textContent.trim() : fallbackTitle || '',
      variant: option ? option.textContent.trim() : '',
      price: Number(el.dataset.price) || (nowEl ? window.znCart.cents(nowEl.textContent) : 0),
      compare: Number(el.dataset.compare) || 0,
      image: img ? img.currentSrc || img.src : ''
    };
  }

  /* bulina din antet + cosul: Kaching daca e activ, altfel sertarul temei sau pagina de cos */
  function revealCart(data) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];

    const kaching = window.kachingCartApi;
    const drawer = document.querySelector('cart-drawer');
    const cartPath = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    if (kaching) {
      /* Kaching vede singur adaugarea si isi deschide cosul; daca n-a facut-o, il deschidem noi */
      setTimeout(async () => {
        if (document.querySelector('#kaching-cart.active')) return;
        try {
          if (kaching.refreshCart) await kaching.refreshCart();
          if (kaching.openCart) kaching.openCart();
        } catch (e) { /* bulina din antet e deja actualizata */ }
      }, 450);
    } else if (window.location.pathname === cartPath) {
      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.refresh === 'function' && cartItems.dataset.empty !== 'true') cartItems.refresh();
      else window.location.reload();
    } else if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents(data, true);
    }
  }

  /* testul cu produsul mai scump: A = doar produse la acelasi pret sau mai ieftine, B = unul mai scump in locul celui de-al treilea.
     Grupa ramane aceeasi pe telefonul clientului, ca sa vada mereu aceeasi lista. */
  function abGroup() {
    try {
      let g = window.localStorage.getItem('zn_fbt_ab');
      if (g !== 'A' && g !== 'B') {
        g = Math.random() < 0.5 ? 'A' : 'B';
        window.localStorage.setItem('zn_fbt_ab', g);
      }
      return g;
    } catch (e) {
      return 'A';
    }
  }

  class ZnFbt extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.t = JSON.parse(this.querySelector('[data-zn-fbt-i18n]').textContent);
      } catch (e) {
        this.t = {};
      }
      this.money = this.dataset.moneyFormat;
      this.main = this.querySelector('[data-zn-main]');
      this.button = this.querySelector('.zn-fbt__add');
      this.label = this.button ? this.button.querySelector('[data-zn-label]') : null;
      this.errorEl = this.querySelector('.zn-fbt__error');
      this.foot = this.querySelector('[data-zn-foot]');
      this.hint = this.querySelector('[data-zn-hint]');
      this.group = 'A';

      /* grupa B vede produsul mai scump in locul celui de-al treilea mai ieftin */
      const test = this.querySelector('[data-zn-test]');
      const swap = this.querySelector('[data-zn-swap]');
      if (test && swap) {
        this.group = abGroup();
        if (this.group === 'B') {
          test.hidden = false;
          swap.hidden = true;
        }
      }

      this.addEventListener('change', this.onChange.bind(this));
      if (this.button) this.button.addEventListener('click', () => this.add(this.recs().filter((r) => r.dataset.on === '1')));
      this.initDeals();

      this.onVariant = this.onMainVariant.bind(this);
      this.onCartAdd = this.onOtherAdd.bind(this);
      document.addEventListener('on:variant:change', this.onVariant);
      document.addEventListener('on:cart:add', this.onCartAdd);
      document.addEventListener('on:line-item:change', this.onCartAdd);
      if (this.main) this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this.onVariant);
      document.removeEventListener('on:cart:add', this.onCartAdd);
      document.removeEventListener('on:line-item:change', this.onCartAdd);
    }

    /* recomandarile vizibile (cea din test apare doar in grupa B) */
    recs() {
      return Array.from(this.querySelectorAll('[data-zn-rec]')).filter((r) => !r.hidden);
    }

    setPrice(row, price, compare) {
      row.dataset.price = price;
      row.dataset.compare = Math.max(compare || 0, price);
      row.querySelector('[data-zn-price]').textContent = formatMoney(price, this.money);
      const was = row.querySelector('[data-zn-item-was]');
      if (was) {
        was.hidden = !(compare > price);
        if (compare > price) was.textContent = formatMoney(compare, this.money);
      }
    }

    setImage(row, src) {
      const img = src ? row.querySelector('[data-zn-img]') : null;
      if (!img) return;
      img.srcset = `${sized(src, 120)} 120w, ${sized(src, 160)} 160w`;
      img.src = sized(src, 160);
    }

    /* produsul paginii: in total doar daca se poate cumpara si nu e deja in cos; atunci blocul are butonul lui */
    setMain(on, note) {
      if (!this.main) return;
      this.main.dataset.on = on ? '1' : '0';
      this.main.classList.toggle('is-off', !on);
      const kicker = this.main.querySelector('[data-zn-note]');
      if (kicker) kicker.textContent = note;
      const inCart = this.main.dataset.inCart === '1';
      if (this.hint) this.hint.textContent = inCart ? this.t.pick_hint_in_cart : this.t.pick_hint;
      if (this.button) this.button.hidden = !inCart;
    }

    onChange(evt) {
      const check = evt.target.closest('[data-zn-check]');
      if (check) {
        const row = check.closest('[data-zn-rec]');
        row.dataset.on = check.checked ? '1' : '0';
        row.classList.toggle('is-on', check.checked);
        this.clearError();
        this.sync();
        return;
      }
      const select = evt.target.closest('[data-zn-select]');
      if (!select) return;
      const row = select.closest('[data-zn-item]');
      const option = select.options[select.selectedIndex];
      row.dataset.id = option.value;
      this.setPrice(row, Number(option.dataset.price), Number(option.dataset.compare));
      this.setImage(row, option.dataset.image);
      this.clearError();
      this.sync();
    }

    /* produsul paginii urmeaza varianta aleasa in formularul de sus */
    onMainVariant(evt) {
      if (!this.main) return;
      const detail = evt.detail || {};
      const formId = this.dataset.mainForm;
      /* form.id ar intoarce campul <input name="id">, nu atributul: citim atributul */
      const eventForm = detail.form && detail.form.getAttribute ? detail.form.getAttribute('id') : null;
      if (formId && eventForm && eventForm !== formId) return;
      const variant = detail.variant;
      if (variant) this.main.dataset.id = variant.id;
      if (this.main.dataset.inCart === '1') this.setMain(false, this.t.in_cart);
      else if (variant && variant.available) this.setMain(true, this.t.this_item);
      else this.setMain(false, this.t.unavailable);
      this.sync();
    }

    /* produsul paginii a intrat in cos (din butonul de sus sau din cos): blocul ramane cu butonul lui pentru cele bifate */
    onOtherAdd(evt) {
      if (!this.main || this.contains(evt.target)) return;
      const detail = evt.detail || {};
      if (String(detail.variantId) !== String(this.main.dataset.id)) return;
      this.main.dataset.inCart = '1';
      this.setMain(false, this.t.in_cart);
      this.sync();
    }

    /* totalul produselor bifate (produsul paginii nu e in lista); apare doar cand e bifat ceva */
    sync() {
      const t = this.t;
      const checked = this.recs().filter((r) => r.dataset.on === '1');
      const rows = checked;
      let sum = 0;
      let was = 0;
      rows.forEach((row) => {
        sum += Number(row.dataset.price) || 0;
        was += Number(row.dataset.compare) || Number(row.dataset.price) || 0;
      });
      if (this.foot) this.foot.hidden = checked.length === 0;
      const count = this.querySelector('[data-zn-count]');
      if (count) count.textContent = rows.length === 1 ? t.total_one : String(t.total_other || '').replace('__n__', rows.length);
      this.querySelector('[data-zn-sum]').textContent = formatMoney(sum, this.money);
      const wasEl = this.querySelector('[data-zn-was]');
      wasEl.textContent = formatMoney(was, this.money);
      wasEl.hidden = !(was > sum);
      const save = this.querySelector('[data-zn-save]');
      save.textContent = String(t.save || '').replace('__a__', formatMoney(was - sum, this.money));
      save.hidden = !(was > sum);
      if (this.label && !this.classList.contains('is-done')) {
        this.label.textContent = checked.length > 1 ? String(t.add_some || '').replace('__n__', checked.length) : t.add_one;
      }
      if (this.button) this.button.disabled = checked.length === 0;
    }

    clearError() {
      if (this.errorEl && !this.errorEl.hidden) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    /* butonul principal "Adauga in cos" a pus produsul paginii in cos: urmeaza cele bifate (product-form.js) */
    addPicked() {
      const checked = this.recs().filter((r) => r.dataset.on === '1');
      if (checked.length) return this.add(checked);
      return null;
    }

    /* pune in cos produsele bifate, dintr-o singura cerere, cu grupa testului (proprietate ascunsa, pentru analiza) */
    async add(rows) {
      if (this.busy || !rows || !rows.length) return;
      const items = rows.map((row) => ({ id: Number(row.dataset.id), quantity: 1, properties: { _zn_fbt: this.group } }));

      this.busy = true;
      this.clearError();
      this.classList.add('is-busy');
      if (this.button) this.button.setAttribute('aria-busy', 'true');
      const token = instant() ? window.znCart.begin(rows.map((row) => lineOf(row))) : null;
      try {
        const data = await addItems(items);
        if (token) await window.znCart.finish(token, data);
        else revealCart(data);
        this.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: items[0].id, items: data.items }
        }));
        /* randurile adaugate raman in lista, debifate si marcate "Adaugat in cos" */
        rows.forEach((row) => {
          const check = row.querySelector('[data-zn-check]');
          if (check) {
            check.checked = false;
            check.disabled = true;
          }
          row.dataset.on = '0';
          row.classList.remove('is-on');
          row.classList.add('is-added');
          row.querySelectorAll('select').forEach((select) => { select.disabled = true; });
          const state = row.querySelector('[data-zn-state]');
          if (state) state.hidden = false;
        });
        this.sync();
      } catch (e) {
        if (token) window.znCart.fail(token, e.description || this.t.error);
        this.errorEl.textContent = e.description || this.t.error;
        this.errorEl.hidden = false;
      } finally {
        this.busy = false;
        this.classList.remove('is-busy');
        if (this.button) this.button.removeAttribute('aria-busy');
      }
    }

    /* caruselul cu reduceri: sageti (doar unde chiar se poate derula) si un buton de adaugare pe fiecare card */
    initDeals() {
      const track = this.querySelector('[data-zn-deals-track]');
      if (!track) return;
      const prev = this.querySelector('[data-zn-deals-prev]');
      const next = this.querySelector('[data-zn-deals-next]');
      const nav = prev ? prev.parentNode : null;
      let frame = 0;
      const update = () => {
        frame = 0;
        const max = track.scrollWidth - track.clientWidth;
        if (nav) nav.hidden = max <= 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      const schedule = () => { if (!frame) frame = window.requestAnimationFrame(update); };
      const step = (dir) => {
        const card = track.querySelector('.zn-deal');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 12;
        const by = card ? (card.offsetWidth + gap) * 2 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * by, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();

      /* varianta aleasa in card: pretul, pretul vechi si procentul se schimba pe loc */
      track.addEventListener('change', (evt) => {
        const select = evt.target.closest('[data-zn-deal-select]');
        if (!select) return;
        const card = select.closest('[data-zn-deal]');
        const option = select.options[select.selectedIndex];
        const price = Number(option.dataset.price);
        const compare = Number(option.dataset.compare);
        card.dataset.id = option.value;
        card.querySelector('[data-zn-deal-now]').textContent = formatMoney(price, this.money);
        const was = card.querySelector('[data-zn-deal-was]');
        const off = card.querySelector('[data-zn-deal-off]');
        const onSale = compare > price;
        was.hidden = !onSale;
        off.hidden = !onSale;
        if (onSale) {
          was.textContent = formatMoney(compare, this.money);
          off.textContent = '−' + Math.round(((compare - price) * 100) / compare) + '%';
        }
      });

      track.addEventListener('click', async (evt) => {
        const button = evt.target.closest('[data-zn-deal-add]');
        if (!button) return;
        const card = button.closest('[data-zn-deal]');
        if (card.classList.contains('is-busy')) return;
        const label = button.querySelector('[data-zn-label]');
        const error = card.querySelector('.zn-deal__error');
        if (error) error.hidden = true;
        card.classList.add('is-busy');
        button.setAttribute('aria-busy', 'true');
        const token = instant() ? window.znCart.begin([lineOf(card)]) : null;
        try {
          const id = Number(card.dataset.id);
          const data = await addItems([{ id, quantity: 1 }]);
          if (token) await window.znCart.finish(token, data);
          else revealCart(data);
          this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: id, items: data.items } }));
          card.classList.add('is-done');
          label.textContent = this.t.added_one;
          clearTimeout(card.doneTimer);
          card.doneTimer = setTimeout(() => {
            card.classList.remove('is-done');
            label.textContent = this.t.add;
          }, 2000);
        } catch (e) {
          if (token) window.znCart.fail(token, e.description || this.t.error);
          if (error) {
            error.textContent = e.description || this.t.error;
            error.hidden = false;
          }
        } finally {
          card.classList.remove('is-busy');
          button.removeAttribute('aria-busy');
        }
      });
    }
  }

  /* pagina de cos: carduri cu cate un buton */
  class ZnFbtCart extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.t = JSON.parse(this.querySelector('[data-zn-fbt-i18n]').textContent);
      } catch (e) {
        this.t = {};
      }
      this.money = this.dataset.moneyFormat;
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', (evt) => {
        const button = evt.target.closest('.zn-fbt-cart__add');
        if (button) this.add(button.closest('[data-zn-item]'));
      });
    }

    onChange(evt) {
      const select = evt.target.closest('[data-zn-select]');
      if (!select) return;
      const card = select.closest('[data-zn-item]');
      const option = select.options[select.selectedIndex];
      const price = Number(option.dataset.price);
      const compare = Number(option.dataset.compare);
      card.dataset.id = option.value;
      const now = card.querySelector('[data-zn-price]');
      now.textContent = formatMoney(price, this.money);
      now.classList.toggle('is-sale', compare > price);
      const was = card.querySelector('[data-zn-was]');
      was.textContent = formatMoney(compare, this.money);
      was.hidden = !(compare > price);
      const img = card.querySelector('[data-zn-img]');
      if (img && option.dataset.image) {
        img.srcset = `${sized(option.dataset.image, 200)} 200w, ${sized(option.dataset.image, 300)} 300w, ${sized(option.dataset.image, 400)} 400w`;
        img.src = sized(option.dataset.image, 400);
      }
    }

    async add(card) {
      if (!card || card.classList.contains('is-busy')) return;
      const button = card.querySelector('.zn-fbt-cart__add');
      const label = card.querySelector('[data-zn-label]');
      const error = card.querySelector('.zn-fbt__error');
      error.hidden = true;
      card.classList.add('is-busy');
      button.setAttribute('aria-busy', 'true');
      try {
        const id = Number(card.dataset.id);
        const data = await addItems([{ id, quantity: 1 }]);
        revealCart(data);
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: id, items: data.items } }));
        card.classList.add('is-done');
        label.textContent = this.t.added_one;
        clearTimeout(card.doneTimer);
        card.doneTimer = setTimeout(() => {
          card.classList.remove('is-done');
          label.textContent = this.t.add;
        }, 2000);
      } catch (e) {
        error.textContent = e.description || this.t.error;
        error.hidden = false;
      } finally {
        card.classList.remove('is-busy');
        button.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('zn-fbt', ZnFbt);
  /* product-form.js il cheama dupa ce produsul paginii a intrat in cos */
  window.znFbt = {
    addPicked(form) {
      const id = form && form.getAttribute ? form.getAttribute('id') : '';
      const block = id ? document.querySelector(`zn-fbt.zn-fbt--pick[data-main-form="${id}"]`) : null;
      return block && typeof block.addPicked === 'function' ? block.addPicked() : null;
    }
  };
  window.customElements.define('zn-fbt-cart', ZnFbtCart);
})();
